import * as React from 'react';

export function SvgChevronRight() {
  return (
    <span aria-hidden={true} data-testid="ads-refreshed-icon">
      <svg viewBox="-2 -2 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M7.94 6 3.97 2.03 5.03.97l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06z"
          clipRule="evenodd"
        />
      </svg>
    </span>
  );
}
